import { CoverImage } from '@components';
import { addTrailingSlash } from '@utils';

export const RelatedPostCard: React.FC<{
  title?: string | null;
  coverImage?: string | { sourceUrl?: string | null | undefined } | null;
  href?: string;
}> = ({ title, coverImage, href }) => (
  <div className=':hover:after:right-2 relative m-2 flex items-center overflow-hidden rounded-xl shadow-lg after:absolute after:right-4 after:top-1/2 after:block after:h-3 after:w-3 after:rotate-[-45deg] after:border-b-2 after:border-r-2 lg:static lg:block lg:h-auto lg:rounded-3xl after:lg:hidden'>
    <div className='relative mb-0 flex-1 leading-[0] hover:opacity-80 lg:mb-5'>
      {coverImage && (
        <CoverImage title={title} coverImage={coverImage} href={href} />
      )}
    </div>
    <div className='flex-1 px-[18px] lg:p-[18px]'>
      <div className='mb-3 text-lg leading-snug lg:font-bold'>
        <a href={addTrailingSlash(href) || '#'}>{title}</a>
      </div>
    </div>
  </div>
);
